import config from 'login/config/index.js';

class ConfigService {
    setFacebookAppId(facebookAppId) {
        this.facebookAppId = facebookAppId;
    }

    getFacebookAppId() {
        return this.facebookAppId;
    }

    setServerStartupTimestampMillis(startupTimestampMillis) {
        this.startupTimestampMillis = startupTimestampMillis;
    }

    getServerStartupTimestampMillis() {
        return this.startupTimestampMillis;
    }

    getLoadingImageUrl() {
        return `${config.endpoint.widget}/assets/img/loading-36px.svg?${this.getServerStartupTimestampMillis()}`;
    }

    getFacebookImageUrl() {
        return `${config.endpoint.widget}/assets/img/login/logo-facebook.png?${this.getServerStartupTimestampMillis()}`;
    }

    getGarageRedirectionUrl() {
        return this.garageRedirectionUrl;
    }

    setGarageRedirectionUrl(garageRedirectionUrl) {
        this.garageRedirectionUrl = garageRedirectionUrl;
    }
}

export default new ConfigService();



// WEBPACK FOOTER //
// ./src/services/ConfigsService/ConfigsService.js